import server_api from "data/server_apis/server_api";

export const getCustomers = (page = 1, filters = {}) => {
  const params = new URLSearchParams({
    page,
    secondary_phone: filters.secondary_phone || "",
    first_name: filters.first_name || "",
    last_name: filters.last_name || "",
    employee_id: filters.employee_id || "",
  });
  return server_api.get(`/accounts/customer?${params.toString()}`);
};

export const deleteCustomer = (id) => {
  return server_api.delete(`/accounts/customer/${id}`);
};

export const updateCustomer = (id, data) => {
  return server_api.patch(`/accounts/customer/${id}`, data);
};

export const activateCustomer = (id) => {
  return server_api.get(`/accounts/customer/${id}/activate`);
};